import {Injectable} from '@angular/core';
import { EnvServices} from './env.services';
// import { LanguageUtils} from '../../utils/src/language.utils';

// const zendeskConfig = require('./3rdPartyScript/zendeskConfig');
// const gaConfig = require('./3rdPartyScript/googleAnalyticsConfig');
// const beusableConfig = require('./3rdPartyScript/beusableConfig');
const chatbotConfig = require('./3rdPartyScript/chatbotConfig');

interface Scripts {
    name: string;
    id: string;
    src: string;
}

// const ScriptStore: Scripts[] = [
//     {name: 'zendesk', id: 'ze-snippet', src: 'https://static.zdassets.com/ekr/snippet.js?key=f9917c5f-6763-4335-81ed-6743feefeeca'}
// ];

@Injectable()
export class ScriptService {

    private scripts: any = {};
    // zendeskUseFlag = false;
    constructor(private envServices: EnvServices) {
        // ScriptStore.forEach((script: any) => {
        //     this.scripts[script.name] = {
        //         loaded: false,
        //         id: script.id,
        //         src: script.src
        //     };
        // });
        //
        // this.zendeskUseFlag = this.envServices.getZendeskUseFlag();
    }

    load(_scripts: string[]) {
        const promises: any[] = [];

        _scripts.forEach((script) =>
            promises.push(this.loadScript(script))
        );

        return Promise.all(promises);
    }

    loadScript(name: string) {
        return new Promise((resolve, reject) => {
            if (this.scripts[name].loaded) {
                resolve({script: name, loaded: true, status: 'Already Loaded'});
            } else {
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.id = this.scripts[name].id;
                script.src = this.scripts[name].src;

                    script.onload = () => {
                        this.scripts[name].loaded = true;
                        resolve({script: name, loaded: true, status: 'Loaded'});
                    };

                script.onerror = (error: any) => resolve({script: name, loaded: false, status: 'Loaded'});
                document.getElementsByTagName('head')[0].appendChild(script);
            }
        });
    }

    init() {
        // if (global['firstLoad']) {
        //     global['firstLoad'] = false;
        //     if (this.zendeskUseFlag) {
        //         global['firstLoad'] = false;
        //         this.load(['zendesk']).then(data => {
        //             console.log('script loaded ', data);
        //             zendeskConfig.zendeskMenu.setDictionary();
        //             const user = {
        //                 name: global['loginUser'].userNm,
        //                 email: global['loginUser'].userEmail
        //             };
        //             zendeskConfig.zendeskMenu.identify(user);
        //
        //             let userLang = 'en';
        //             userLang = LanguageUtils.getLangCode();
        //             userLang = /(en|ko|zh|ja)/gi.test(userLang) ? userLang : 'en';
        //             userLang = LanguageUtils.choiceLanguage(userLang);
        //
        //             zendeskConfig.zendeskMenu.setLocale(userLang);
        //
        //         }).catch(error => console.log(error));
        //     }
        //
        //     gaConfig.gaMenu.init();
        //     beusableConfig.beusableMenu.init();
        // }
    }

    initChatbot() {
        chatbotConfig.chatbot.init();
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/src/scriptService.ts